/**
 * @description MultiSelectBox component
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module components/MultiSelectBox
 */

import React from 'react';
import PropTypes from 'prop-types';

import MultiSelectBoxOption from './MultiSelectBoxOption';

import CONSTANTS from "../config/Constants";

/**
 * @description The MultiSelectBox component.
 * @class MultiSelectBox
 * @extends {React.Component}
 */
class MultiSelectBox extends React.Component {

    /**
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false
        };
    }

    /**
     * @inheritdoc
     */
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.options !== nextProps.options || this.state.isExpanded !== nextState.isExpanded;
    }

    /**
     * @inheritdoc
     */
    render() {
        return (
            <div className="MultiSelectBox">
                <label className="MultiSelectBox-status">
                    {this.props.options.every(option => option.isSelected === CONSTANTS.ROUTE_SELECTION_STATE.complete)
                        ? 'All routes'
                        : this.props.options.every(
                              option => option.isSelected === CONSTANTS.ROUTE_SELECTION_STATE.deselected
                          )
                        ? 'No routes'
                        : 'Multiple routes'}
                    <button type="button" onClick={this.onToggleExpand.bind(this)}>
                        <span className="material-icons">
                            {this.state.isExpanded
                                ? 'keyboard_arrow_up'
                                : 'keyboard_arrow_down'}
                        </span>
                    </button>
                </label>
                {this.state.isExpanded && (
                    <ul className="MultiSelectBox-list">
                        {this.props.options &&
                            this.props.options.map(option => (
                                <li key={option.name}>
                                    <MultiSelectBoxOption
                                        onToggleOption={
                                            this.props.onToggleOption
                                        }
                                        name={option.name}
                                        value={option.name}
                                        isSelected={
                                            option.isSelected
                                        }></MultiSelectBoxOption>
                                    {option.options && (
                                        <ul>
                                            {option.options.map(subOption => (
                                                <li key={subOption.id}>
                                                    <MultiSelectBoxOption
                                                        onToggleOption={
                                                            this.props
                                                                .onToggleOption
                                                        }
                                                        name={subOption.name}
                                                        value={subOption.id}
                                                        isSelected={
                                                            subOption.isSelected
                                                        }></MultiSelectBoxOption>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            ))}
                    </ul>
                )}
            </div>
        );
    }

    /**
     * @description Handles the toggling of the multiselectbox.
     */
    onToggleExpand() {
        const newState = !this.state.isExpanded;
  
        this.closeList = this.closeSelectBox.bind(this);
        newState && document.addEventListener('click', this.closeList); 
        this.setState({
            isExpanded: newState
        });
    }

    /**
     * @description Closes the multiselectbox.
     * @param {Object} event - the click event.
     * @returns {void}
     */
    closeSelectBox(event) {
        if (event && event.target.closest('.MultiSelectBox')) {
            return;
        }

        document.removeEventListener('click', this.closeList);
        this.setState({
            isExpanded: false
        });
    }
}

MultiSelectBox.defaultProps = {
    options: [],
    onToggleOption: () => null
};

MultiSelectBox.propTypes = {
    options: PropTypes.array.isRequired,
    onToggleOption: PropTypes.func.isRequired
};

export default MultiSelectBox;
